export const SpeakerConfig = {
  postNewSession: "/Speaker/GetSpeakerById",
  getSpeakersByEventId: "/Event/GetSpeakersByEventId",
  getSpeakerById: "/Speaker/GetSpeakerBySpeakerId",
  updateSpeakerDetails : "/Speaker/UpdateSpeakerDetails"
};